export default __webpack_public_path__ + "static/media/react.e7574af2.svg";